//////////////////////////////

module.exports = (type) => {
    var schema = {
        label: {
            type: type.STRING(1024),
            allowNull: false,
            unique: true,
        },
        created: {
            type: type.DATE,
            allowNull: false,
            defaultValue: type.NOW,
        },
        config: {
            type: type.JSON,
            allowNull: false,
            defaultValue: {},
        },
        customer_id: {
            type: type.INTEGER,
            allowNull: false,
            references: {
                model       : 'customers',
                key         : 'id',
                constraints : true,
                store_name  : 'customer',
            }
        },
        created_by: {
            type: type.INTEGER,
            allowNull: false,
            references: {
                model       : 'users',
                key         : 'id',
                constraints : true,
                store_name  : 'user',
            }
        },
        sezione: {
            type: type.VIRTUAL,
            allowNull: false,
            defaultValue: '',
        },
        rassegna: {
            type: type.VIRTUAL,
            allowNull: false,
            defaultValue: '',
        },
        date_shift: {
            type: type.VIRTUAL,
            integer: true,
            allowNull: false,
            defaultValue: 0,
        },
        active: {
            type: type.BOOLEAN,
            allowNull: false,
            defaultValue: true,
        },
        id: {
          type: type.INTEGER,
          primaryKey: true,
          autoIncrement: true
        },
    };

    return schema;
}
